import React, { useState } from "react";
import { useUser } from '../../components/UserContext';
import { useApiClient } from "../../components/useApiClient";
import "./ConsentStyleSheet.css";
interface TermsConsentModalProps {
  isOpen: boolean;
  userName?: string;
  onAccepted: () => void;
  onLogout: () => void;
}

const TermsConsentModal: React.FC<TermsConsentModalProps> = ({
  isOpen,
  userName,
  onAccepted,
  onLogout,
}) => {
    const [isChecked, setIsChecked] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const { getAccessToken } = useUser();
    const { put, post, delete: del } = useApiClient();

  if (!isOpen) return null;

  const handleAccept = async () => {
    if (!isChecked || isSubmitting) return;

    try {
      setIsSubmitting(true);
      setError(null);

        const accessToken = await getAccessToken();

        if (!accessToken) throw new Error("Unable to obtain access token.  Please try again.");

        const formData = new FormData();

        const response = await put <boolean>(`eula/acceptTerms`, accessToken, formData);

      if (!response) {
        throw new Error("Unable to record acceptance.");
      }

      onAccepted();
    } catch (err: any) {
      setError(err.message || "Something went wrong applying your acceptance. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="terms-modal-backdrop" aria-modal="true" role="dialog">
      <div className="terms-modal">
        <div className="terms-modal-header">
          <h2>Terms of Use Acceptance</h2>
        </div>

        <div className="terms-modal-body">
          {userName && (
            <p className="terms-modal-greeting">Welcome, {userName}.</p>
          )}
            <p>Before continuing, please confirm that you have read and agree to the:</p>
                  <p className="terms-modal-links"><a href="/terms" target="_blank" rel="noreferrer">Terms of Use</a>
             and
            <a href="/privacy" target="_blank" rel="noreferrer">Privacy Policy</a></p>
            <p className="terms-meta">
                The Service is licensed to authorised users on a
                non-exclusive, non-transferable basis for the duration of their
                permitted access.
            </p>

            <div className="terms-consent-row">
                <label className="terms-consent-label">
                    <span>
                        I confirm that I have read and agree to the terms of use.
                    </span>

                    <input
                        type="checkbox"
                        checked={isChecked}
                        onChange={(e) => setIsChecked(e.target.checked)}
                    />
                </label>
            </div>
          {error && <p className="terms-error">{error}</p>}
        </div>

        <div className="terms-modal-footer">
          <button
            type="button"
            className="terms-btn-secondary"
            onClick={onLogout}
            disabled={isSubmitting}
          >
            Return
          </button>
          <button
            type="button"
            className="terms-btn-primary"
            onClick={handleAccept}
            disabled={!isChecked || isSubmitting}
          >
            {isSubmitting ? "Saving..." : "Accept and continue"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TermsConsentModal;
